import React from 'react'
import { DiscordIcon, XBrandIcon } from '../Icons'
import styled from 'styled-components/macro'

type TSocialLink = {
  Icon: any
  name: string
  link: string
}
const SupportedSocialLinks: Array<TSocialLink> = [
  {
    Icon: XBrandIcon,
    link: window.__RUNTIME_CONFIG__.SOCIAL_X || 'https://x.com/NiiFiDAO',
    name: 'X',
  },
  {
    Icon: DiscordIcon,
    link: window.__RUNTIME_CONFIG__.SOCIAL_DISCORD || 'https://discord.gg/ssjzvjZX89',
    name: 'Discord',
  },
]
const StyledSocialLink = styled.a`
  padding: 0.25rem;
  border-radius: 50%;
  color: ${({ theme }) => theme.bg4};
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  justify-content: center;
`
const StyledSocialLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.625rem;
`
function SocialLink({ name, Icon, link }: TSocialLink) {
  return (
    <StyledSocialLink href={link} target="_blank" id={name}>
      <Icon width={'24'} height={'24'} />
    </StyledSocialLink>
  )
}
export default function SocialLinks() {
  return (
    <StyledSocialLinkWrapper>
      {SupportedSocialLinks.map((socialLink, socialLinkIdx) => (
        <SocialLink key={socialLinkIdx} {...socialLink} />
      ))}
    </StyledSocialLinkWrapper>
  )
}
